import { render, staticRenderFns } from "./Monitors.vue?vue&type=template&id=51f851a4&scoped=true"
import script from "./Monitors.vue?vue&type=script&lang=js"
export * from "./Monitors.vue?vue&type=script&lang=js"
import style0 from "./Monitors.vue?vue&type=style&index=0&id=51f851a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f851a4",
  null
  
)

export default component.exports